import { Route } from '@angular/router'
import { TaxonomyDetailComponent } from '../taxonomy-detail/taxonomy-detail.component'
import { createTaxonomyDefinition } from '../taxonomy-detail/taxonomy.definition'

import { PermissionGuard } from '../../abacus/guards/permission.guard'
import { AuthGuard } from '../../abacus/guards/auth.guard'

import { InitiativeTypeListComponent } from './initiative-type-list/initiative-type-list.component'

export const initiativeTypeRoutes: Route[] = [
  {
    path: 'initiative-types',
    component: InitiativeTypeListComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      permission: 'browsePolicyInitiativeTaxonomies'
    }
  },
  {
    path: 'initiative-types/:id/edit',
    redirectTo: 'initiative-types/:id',
    pathMatch: 'full'
  },
  {
    path: 'initiative-types/:id',
    component: TaxonomyDetailComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      definition: createTaxonomyDefinition({
        className: 'InitiativeType',
        nameSingular: 'Initiative Type',
        namePlural: 'Initiative Types',
        path: 'initiative-types',
        slug: 'taxonomies/initiative-types',
        title: 'Initiative Types'
      }),
      permission: 'readPolicyInitiativeTaxonomies'
    }
  }
]
